import { NavLink } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';

interface Props {
  icon: LucideIcon;
  label: string;
  path: string;
}

const HeaderNavItem = ({ icon: Icon, label, path }: Props) => {
  return (
    <NavLink
      to={path}
      className={({ isActive }) =>
        `flex flex-col items-center justify-center
         min-w-[110px]
         h-[54px]
         rounded-xl
         transition-all duration-300
         ${
           isActive
             ? 'bg-gradient-to-r from-[#1F5E7A] to-[#61C3AB] text-white shadow-md'
             : 'text-gray-600 hover:bg-gray-100 hover:text-[#1F5E7A]'
         }`
      }
    >
      <Icon size={18} className="mb-1" />

      <span className="text-xs font-medium text-center">{label}</span>
    </NavLink>
  );
};

export default HeaderNavItem;
